import React from 'react';
import { RadioGroup } from '@headlessui/react';
import cx from 'classnames';

type Props = {
  value: string;
  title: string;
  tagline?: string;
  badge?: string;
  compact?: boolean;
};

function ProductCard({ value, title, tagline, badge, compact = false }: Props) {
  return (
    <RadioGroup.Option
      value={value}
      className={({ checked, disabled }) =>
        cx(
          'flex w-full cursor-pointer items-start justify-between gap-4 rounded-2xl border-2 p-4 text-left font-lexend transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-retino-darkviolet',
          compact ? 'sm:p-5' : 'sm:p-7',
          checked ? 'border-retino-darkviolet bg-retino-lightviolet/15' : 'border-slate-200 bg-white',
          disabled ? 'cursor-not-allowed opacity-60' : !checked && 'hover:border-retino-darkviolet/40',
        )
      }
    >
      {({ checked }) => (
        <>
          <span className="flex min-w-0 flex-1 flex-col gap-2">
            <span className="flex flex-wrap items-center gap-3">
              <RadioGroup.Label
                as="span"
                className={cx(
                  'min-w-0 break-words font-semibold leading-tight text-retino-darkviolet',
                  compact ? 'text-xl sm:text-[22px]' : 'text-[22px] sm:text-[26px]',
                )}
              >
                {title}
              </RadioGroup.Label>
              {badge && (
                <span className="whitespace-nowrap rounded-full bg-retino-limegreen px-2.5 py-1 text-[11px] font-semibold uppercase leading-none text-retino-darkviolet">
                  {badge}
                </span>
              )}
            </span>
            {tagline && (
              <RadioGroup.Description as="span" className="text-base leading-snug text-retino-darkgrey sm:text-sm">
                {tagline}
              </RadioGroup.Description>
            )}
          </span>
          <span
            aria-hidden="true"
            className={cx(
              'flex size-6 shrink-0 items-center justify-center rounded-full border-[1.5px] transition-colors',
              checked ? 'border-retino-darkviolet bg-retino-darkviolet' : 'border-slate-300 bg-white',
            )}
          >
            {checked && (
              <svg
                className="size-[13px] text-white"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
              >
                <path d="m3.5 8.5 3 3 6-7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </span>
        </>
      )}
    </RadioGroup.Option>
  );
}

export default ProductCard;
